import { call, put, takeLatest } from 'redux-saga/effects';
import {
  USER_PREFERENCE_QUERY_START,
  getUserPreferenceQuerySuccessAction,
  getUserPreferenceQueryFailedAction,
} from '../actions/UserPreferenceAction';
import ApiUtil from 'src/utils/ApiUtil';
import { setCurrentCountryCodeAction } from 'src/actions/CurrentCountryCodeQueryAction';
import { isLoginMode, isWidget } from 'src/config/Config';
import { setBannerContentQueryStart } from 'src/actions/BannerContentAction';

export function* getUserPreference() {
  try {
    const parameters: any = {};
    // @ts-expect-error
    const response = yield call(
      ApiUtil.callApiWithTimeout,
      'getuserpreference',
      parameters,
    );

    yield put(getUserPreferenceQuerySuccessAction(response));
    const currentCountryCode: string = response.currentCountryCode;
    yield put(setCurrentCountryCodeAction(currentCountryCode));
    if (isLoginMode()) {
      yield put(setBannerContentQueryStart(currentCountryCode, isWidget()));
    }
  } catch (error) {
    console.error('Call API getuserpreference error' + error);
    yield put(getUserPreferenceQueryFailedAction());
  }
}

export default function* userPreferenceQuery() {
  yield takeLatest(USER_PREFERENCE_QUERY_START, getUserPreference);
}
